import { DIC, RATE_UNIT } from '@Bill/constants'
import i18n from '@/locales'

export const getFieldCn = (str) => {
  if (DIC[str]) {
    return DIC[str]
  }
  return str
}

export const toCN = v => {
  const unit = RATE_UNIT[v]
  return unit || v
}

export const toVmName = obj => {
  const type = obj.res_type
  let title = type
  if (type === 'baremetal') {
    return (obj.brand || i18n.t('bill.text_163')) + '-' + (obj.model || i18n.t('bill.text_163'))
  }
  if (type === 'gpu') {
    return (obj.brand || i18n.t('bill.text_163')) + '-' + (obj.model || i18n.t('bill.text_163'))
  }
  if (type === 'cpu') {
    title = 'CPU'
  }
  if (type === 'server') {
    title = i18n.t('bill_resource_type.server')
  }
  if (type === 'lb') {
    title = i18n.t('bill_resource_type.lb')
  }
  if (type === 'oss') {
    title = i18n.t('bill_resource_type.oss')
  }
  if (type === 'mem') {
    title = i18n.t('bill_resource_type.mem')
  }
  if (type === 'rds') {
    if (obj.model) {
      title = `RDS - ${obj.model}`
    } else {
      title = 'RDS'
    }
  }
  if (type === 'rds_disk') {
    title = i18n.t('bill_resource_type.rds_disk')
  }
  if (type === 'FortressAircraft') {
    title = i18n.t('bill_resource_type.FortressAircraft')
  }
  if (type === 'DBAudit') {
    title = i18n.t('bill_resource_type.DBAudit')
  }
  if (type === 'WTPS') {
    title = i18n.t('bill_resource_type.WTPS')
  }
  if (type === 'disk') {
    let diskType = ''
    if (obj.disk_type === 'data') {
      diskType = ` - ${i18n.t('common_433')}`
    } else if (obj.disk_type === 'sys') {
      diskType = ` - ${i18n.t('common_432')}`
    }
    title = i18n.t('bill_resource_type.disk') + ' - ' + getFieldCn(obj.medium_type + ' - ' + obj.storage_type + diskType)
  }
  if (type === 'snapshot') {
    title = i18n.t('bill_resource_type.snapshot') + ' - ' + getFieldCn(obj.medium_type + ' - ' + obj.storage_type)
  }
  if (type === 'network_card') {
    title = getFieldCn(obj.type + ' - ' + obj.category)
  }
  if (type === 'eip') {
    if (obj.model) {
      if (obj.model.includes('::')) {
        const modelArr = obj.model.split('::')
        title = `${i18n.t('bill_resource_type.eip')} - ${modelArr[0]} - ${modelArr[1]}`
      } else {
        title = `${i18n.t('bill_resource_type.eip')} - ${obj.model}`
      }
    }
  }
  title = (title || '').replace(' -  - ', '') // 去除空字符串引起的错误数据
  if (obj.unit) {
    title += ` (${toCN(obj.unit)})`
  }
  return title
}
